import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=cc2d9f80"
import script from "./PoweredBy.vue?vue&type=script&lang=js"
export * from "./PoweredBy.vue?vue&type=script&lang=js"
import style0 from "./PoweredBy.vue?vue&type=style&index=0&id=cc2d9f80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports